import React from 'react';
import {CompositeDecorator} from 'draft-js';
import type {ContentBlock, ContentState} from 'draft-js';

function mergeTagStrategy(
	contentBlock: ContentBlock,
	callback: (start: number, end: number) => void,
	contentState: ContentState
) {
	contentBlock.findEntityRanges(char => {
		const entityKey = char.getEntity();
		if (!entityKey) return false;
		return contentState.getEntity(entityKey).getType() === 'MERGE_TAG';
	}, callback);
}

interface MergeTagPillProps {
	children: React.ReactNode;
}

function MergeTagPill(props: MergeTagPillProps) {
	return React.createElement(
		'span',
		{
			className:
				'mx-0.5 inline-flex items-center rounded-full bg-amber-50 border border-amber-200 px-2 py-0.5 text-xs font-medium text-amber-800',
			contentEditable: false,
		},
		React.createElement('span', {className: 'mr-1 text-amber-500'}, '{ }'),
		props.children
	);
}

export const mergeTagDecorator = new CompositeDecorator([
	{
		strategy: mergeTagStrategy,
		component: MergeTagPill,
	},
]);
